<template>
  <v-dialog :value="model.active" width="400" persistent>
    <!-- Modal content -->
    <v-card v-if="selected">
      <div class="d-flex justify-space-between align-center pr-2">
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon left> {{ isEditing ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          {{ isEditing ? 'Edit' : 'Add' }} Level
        </v-card-title>
        <v-btn icon @click="closeDialog"><v-icon>fa-close</v-icon></v-btn>
      </div>
      <v-divider></v-divider>

      <v-card-text class="pt-5">
        <v-form v-model="model.valid">
          <v-text-field
            outlined
            dense
            :rules="[formRules.required]"
            clearable
            v-virtual-keyboard
            hide-details
            label="Level Name"
            placeholder="Enter Level Name..."
            v-model.trim="selected.name">
          </v-text-field>

          
          <v-sheet class="d-flex justify-center align-center my-4">
            <v-divider></v-divider>
            <h4 class="px-4">Level Boundary</h4>
            <v-divider></v-divider>
          </v-sheet>

          <div class="mb-2">Elevation (m)</div>
          <v-row>
            <v-col>
              <v-text-field
                outlined
                dense
                clearable
                v-virtual-keyboard
                label="Bottom"
                placeholder="Bottom"
                v-model="selected.bottomElevation">
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                dense
                clearable
                v-virtual-keyboard
                label="Top"
                placeholder="Top"
                v-model="selected.topElevation">
              </v-text-field>
            </v-col>
          </v-row>
          <div class="mb-2">Northing (m)</div>

          <v-row>
            <v-col>
              <v-text-field
                outlined
                dense
                clearable
                v-virtual-keyboard
                label="South"
                placeholder="South"
                v-model="selected.south">
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                dense
                clearable
                v-virtual-keyboard
                label="North"
                placeholder="North"
                v-model="selected.north">
              </v-text-field>
            </v-col>
          </v-row>
          <div class="mb-2">Easting (m)</div>

          <v-row>
            <v-col>
              <v-text-field
                outlined
                dense
                clearable
                v-virtual-keyboard
                label="West"
                placeholder="West"
                v-model="selected.west">
              </v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                outlined
                dense
                clearable
                v-virtual-keyboard
                label="East"
                placeholder="East"
                v-model="selected.east">
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="red" elevation="0" text @click="closeDialog"> close </v-btn>
        <v-spacer></v-spacer>
        <v-btn elevation="0" :disabled="!model.hasChanges" @click="discard"> discard </v-btn>
        <v-btn
          color="primary"
          elevation="0"
          @click="saveChanges"
          :disabled="!model.valid || !model.hasChanges">
          {{ isEditing ? 'Save' : 'Create' }} Level
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import formRules from '@Share/config/form-rules';
  import { ForgeLevel } from '@/scripts/js/forgeModels';
  import { $isEqual } from '@Utils';
  import levelsService from '@/features/Admin/services/levels.service';
  export default {
    name: 'EditLevel',
    data() {
      return {
        level: null,
        sourceLevel: null,
        formRules,
        isEditing: false,
        selected: null,
        selectedCemented: null,
        model: {
          active: false,
          loading: false,
          valid: true,
          hasChanges: false,
        },
      };
    },
    methods: {
      open(level) {
        if (level) {
          this.isEditing = true;
          this.selected = level;
          this.cementSelected();
        } else {
          level = new ForgeLevel();
          level.isExpanded = true;
          level.name = 'New Level';
          this.isEditing = false;
          this.selected = level;
          this.selectedCemented = {};
        }
        this.model.active = true;
      },
      reset() {
        this.model.active = false;
        this.selected = null;
        this.selectedCemented = null;
      },
      closeDialog() {
        if (this.model.hasChanges) {
          const answer = window.confirm('You have unsaved changes on this page! leave anyway?');
          if (answer) {
            this.reset();
            this.discard();
          }
        } else {
          this.reset();
        }
      },
      discard() {
        this.selected = structuredClone(this.selectedCemented);
        this.model.hasChanges = false;
      },
      cementSelected() {
        this.selectedCemented = structuredClone(this.selected);
        this.checkForChanges();
      },
      checkForChanges() {
        if (!this.model.active) return;

        this.model.hasChanges = !$isEqual(this.selected, this.selectedCemented);
      },
      saveChanges() {
        if (this.isEditing) {
          if (this.$store.state.levels.some((o) => o.name == this.selectedCemented.name) && this.selectedCemented.name != this.selected.name) {
            this.$dialog.notify.warning('Level with same name is existing, please enter a unique name.', {
              position: 'top-right',
              timeout: 3000,
            });
            return;
          }
          var index = this.$store.state.levels.findIndex(
            (o) => o.id == this.selectedCemented.id,
          );
          this.$store.state.levels.splice(index, 1, this.selected);
        } else {
          if (this.$store.state.levels.some((o) => o.name == this.selected.name)) {
            this.$dialog.notify.warning(
              'Level with same name is existing, please enter a unique name.',
              {
                position: 'top-right',
                timeout: 3000,
              },
            );
            return;
          }
          this.$store.state.levels.push(this.selected);
        }
        const assetId = this.$store.state.assetId;
        const level = this.selected;
        const isCreating = !this.isEditing;
        const serviceCall = isCreating
          ? levelsService.createLevel(assetId, level)
          : levelsService.editLevel(assetId, level);

        serviceCall.then((response) => {
          if (isCreating && response.data) {
            level.id = response.data;
          }
          this.$store.state.levels = [...this.$store.state.levels];
          this.$dialog.notify.success('Level saved successfully.', {
            position: 'top-right',
            timeout: 3000,
          });
        });
        this.$store.state.forgeService.getMappingExtension3D()?.updateShownLevels();
        this.cementSelected();
        this.closeDialog();
      },
    },
    watch: {
      selected: {
        handler() {
          this.checkForChanges();
        },
        deep: true,
      },
    },
  };
</script>

<style>
  .right-input {
    width: 30%;
    text-align: center;
  }

  .left-title {
    position: absolute;
    left: 41%;
    top: 0px;
    color: black;
    font-size: 10px;
  }

  .right-title {
    position: absolute;
    left: 72%;
    top: 0px;
    color: black;
    font-size: 10px;
  }
  .admin-row {
    margin-top: 10px;
  }
</style>
